var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "选择商品",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.initloading,
                  expression: "initloading",
                },
              ],
              ref: "pram",
              attrs: { model: _vm.pram, "label-width": "90px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择商品：", prop: "tagId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        placeholder: "请选择",
                        filterable: "",
                        "filter-method": _vm.handleSpuSearch,
                      },
                      model: {
                        value: _vm.pram.spuId,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "spuId", $$v)
                        },
                        expression: "pram.spuId",
                      },
                    },
                    _vm._l(_vm.spuLists, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.storeName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handerSubmit } },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }